import httpClient from '../httpClient';

export async function getTaskSisaf(id: string) {
  try {
    const response = await httpClient.get(`/api/taskssisdaf/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter Produto DAF: ' + error);
  }
}

export async function getAllTasksSisAf() {
  try {
    const response = await httpClient.get(`/api/taskssisdaf`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Documentos SisAF: ' + error);
  }
}
